import AddTaxTypeForm from "../../../../component/tax-types/add-tax-types/AddTaxType";

function AddTaxType() {
  return (
    <div className="page-body">
      <AddTaxTypeForm />
    </div>
  );
}

export default AddTaxType;
